<template>
  <div class="w-full p-3">
    <apexchart
      ref="chart"
      v-if="isDataReady"
      :options="chartOptions"
      :series="series"
      type="line"
      height="400"
    />
    <div v-else>Loading...</div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "DurabilityChartTryout",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isDataReady() {
      return Array.isArray(this.data) && this.data.length > 0;
    },
    series() {
      if (!this.isDataReady) return [];

      const values = this.data.map((item) => Number(item.total_score) || 0);
      console.log("Computed values:", values); // Debug log

      return [
        {
          name: "Nilai Tryout",
          data: values,
        },
      ];
    },
    categories() {
      if (!this.isDataReady) return [];

      return this.data.map((item) => item.tryout_name);
    },
    maxValue() {
      if (!this.isDataReady) return 15;
      const max = Math.max(...this.series[0].data);
      return Math.ceil((max + 5) / 5) * 5; // Round up to nearest 5
    },
    chartOptions() {
      return {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
        },
        dataLabels: {
          enabled: true, // Ubah menjadi true untuk memastikan nilai muncul
          offsetY: -10,
          style: {
            fontSize: "12px",
            colors: ["#1e4db7"],
          },
        },
        stroke: {
          curve: "smooth", // Ubah menjadi smooth untuk garis yang lebih halus
          width: 3, // Tambah ketebalan garis
          colors: ["#1e4db7"],
        },
        grid: {
          borderColor: "#f1f1f1",
          row: {
            colors: ["transparent"],
            opacity: 0.5,
          },
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        markers: {
          size: 6, // Perbesar ukuran marker
          colors: ["#1e4db7"],
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 8,
          },
        },
        xaxis: {
          categories: this.categories,
          title: {
            text: "Tryout",
            style: {
              fontSize: "12px",
              fontWeight: 600,
              cssClass: "apexcharts-xaxis-title",
            },
          },
          tickAmount: this.isDataReady ? this.data.length : 5,
          labels: {
            style: {
              fontSize: "12px",
            },
            rotate: -45, // Rotasi label untuk mencegah overlap
            trim: false,
          },
        },
        yaxis: {
          title: {
            text: "Nilai Tryout",
            style: {
              fontSize: "12px",
              fontWeight: 600,
              cssClass: "apexcharts-yaxis-title",
            },
          },
          min: 0,
          max: this.maxValue,
          tickAmount: 5,
          labels: {
            style: {
              fontSize: "12px",
            },
            formatter: (value) => Math.round(value).toString(),
          },
        },
        tooltip: {
          enabled: true,
          shared: true,
          intersect: false,
          custom: ({ series, seriesIndex, dataPointIndex }) => {
            if (!this.isDataReady) return "";

            const value = series[seriesIndex][dataPointIndex];

            return (
              '<div class="custom-tooltip" style="padding: 12px; background: #fff; border: 1px solid #e0e0e0; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">' +
              '<div style="font-weight: 600; margin-bottom: 8px; color: #1e4db7; font-size: 13px;">' +
              `${this.categories[dataPointIndex]}` +
              "</div>" +
              '<div style="display: flex; justify-content: space-between; margin-bottom: 4px; font-size: 12px;">' +
              '<span style="color: #666;">Nilai:</span>' +
              `<span style="font-weight: 600; margin-left: 12px; color: #333;">${value}</span>` +
              "</div>" +
              "</div>"
            );
          },
        },
        theme: {
          mode: "light",
          palette: "palette1",
          monochrome: {
            enabled: false,
            color: "#1e4db7",
            shadeTo: "light",
            shadeIntensity: 0.65,
          },
        },
      };
    },
  },
  watch: {
    data: {
      handler(newData) {
        console.log("Data changed:", newData);
        if (this.$refs.chart) {
          this.$refs.chart.updateOptions(this.chartOptions);
        }
      },
      deep: true,
    },
  },
};
</script>
